// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-tabs{display:flex;gap:8px;margin:0 0 12px 0;flex-wrap:wrap}
.oc-tab{appearance:none;background:#f6f8fb;border:1px solid #dbe1e8;border-radius:8px;padding:8px 12px;line-height:1;cursor:pointer;font-weight:600;color:#374151;transition:all .15s}
.oc-tab:hover{background:#eef3f8}
.oc-tab.active{background:#fff;border-color:#169bd5;color:#169bd5;box-shadow:0 0 0 2px rgba(22,155,213,.12) inset}
.oc-tabs.small .oc-tab{padding:6px 10px;font-weight:500;border-radius:6px}

.oc-tab-pane{background:#fff;border:1px solid #e6eaef;border-radius:10px;padding:16px}

.oc-f-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.oc-f-grid .oc-field{min-width:0}
.oc-field label{display:block;font-size:13px;margin:0 0 6px 0;color:#6b7280}
.oc-input, .oc-select, textarea.oc-input{width:100%;background:#fff;border:1px solid #d1d5db;border-radius:8px;padding:9px 12px;font-size:14px;outline:0;transition:border-color .15s,box-shadow .15s}
.oc-input:focus, .oc-select:focus, textarea.oc-input:focus{border-color:#169bd5;box-shadow:0 0 0 3px rgba(22,155,213,.12)}
textarea.oc-input{resize:vertical}

.oc-actions{display:flex;gap:8px;justify-content:flex-end}
.oc-btn{background:#169bd5;color:#fff;border:none;border-radius:8px;padding:9px 14px;font-weight:700;cursor:pointer}
.oc-btn:hover{filter:brightness(.95)}
.oc-btn.ghost{background:#fff;color:#374151;border:1px solid #d1d5db}
.oc-btn.ghost:hover{background:#f8fafc}

.oc-ico-btn{border:1px solid #e2e8f0;background:#fff;border-radius:8px;padding:6px 8px;cursor:pointer}
.oc-ico-btn:hover{background:#f6f9fc}

.oc-bc.small{font-size:12px;color:#94a3b8;margin-top:2px}
.oc-strong{font-weight:700}

@media (max-width: 1024px){
  .oc-f-grid{grid-template-columns:1fr}
}


.oc-parent-select {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* input + button in one row, same height as other inputs */
.oc-parent-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.oc-parent-clear {
  height: 38px;
  padding-inline: 10px;
  font-size: 13px;
  flex-shrink: 0;
}

/* current selection line (subtle, same width as field) */
.oc-parent-current {
  font-size: 12px;
  color: #6b7280;
  display: flex;
  gap: 4px;
}

.oc-parent-current-label {
  font-weight: 500;
}

.oc-parent-current-value {
  color: #111827;
}

/* list styled like a dropdown but full-width, aligned to field */
.oc-parent-list {
  margin-top: 2px;
  max-height: 180px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow-y: auto;
  padding: 4px;
}

.oc-parent-item {
  width: 100%;
  border: none;
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

.oc-parent-item:hover {
  background: #f3f4f6;
}

.oc-parent-item.active {
  background: #e5f0ff;
  border: 1px solid #93c5fd;
}

.oc-parent-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.oc-parent-id {
  font-size: 11px;
  color: #6b7280;
}

/* empty / helper rows */
.oc-parent-empty {
  padding: 4px 6px;
  font-size: 12px;
  color: #9ca3af;
}












.oc-input-error {
  border-color: #dc2626 !important;
  background-color: #fef2f2;
}

.oc-field-error {
  margin-top: 4px;
  font-size: 12px;
  color: #dc2626;
}

.oc-form-error-banner {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 13px;
}

`, "",{"version":3,"sources":["webpack://./src/components/css/EditCategory.css"],"names":[],"mappings":"AAAA,SAAS,YAAY,CAAC,OAAO,CAAC,iBAAiB,CAAC,cAAc;AAC9D,QAAQ,eAAe,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,mBAAmB;AACrL,cAAc,kBAAkB;AAChC,eAAe,eAAe,CAAC,oBAAoB,CAAC,aAAa,CAAC,+CAA+C;AACjH,uBAAuB,gBAAgB,CAAC,eAAe,CAAC,iBAAiB;;AAEzE,aAAa,eAAe,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,YAAY;;AAErF,WAAW,YAAY,CAAC,6BAA6B,CAAC,QAAQ;AAC9D,qBAAqB,WAAW;AAChC,gBAAgB,aAAa,CAAC,cAAc,CAAC,gBAAgB,CAAC,aAAa;AAC3E,yCAAyC,UAAU,CAAC,eAAe,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,cAAc,CAAC,SAAS,CAAC,4CAA4C;AACrM,2DAA2D,oBAAoB,CAAC,yCAAyC;AACzH,kBAAkB,eAAe;;AAEjC,YAAY,YAAY,CAAC,OAAO,CAAC,wBAAwB;AACzD,QAAQ,kBAAkB,CAAC,UAAU,CAAC,WAAW,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,eAAe,CAAC,cAAc;AACnH,cAAc,sBAAsB;AACpC,cAAc,eAAe,CAAC,aAAa,CAAC,wBAAwB;AACpE,oBAAoB,kBAAkB;;AAEtC,YAAY,wBAAwB,CAAC,eAAe,CAAC,iBAAiB,CAAC,eAAe,CAAC,cAAc;AACrG,kBAAkB,kBAAkB;;AAEpC,aAAa,cAAc,CAAC,aAAa,CAAC,cAAc;AACxD,WAAW,eAAe;;AAE1B;EACE,WAAW,yBAAyB;AACtC;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;;;;;;;;;;;;AAaA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".oc-tabs{display:flex;gap:8px;margin:0 0 12px 0;flex-wrap:wrap}\n.oc-tab{appearance:none;background:#f6f8fb;border:1px solid #dbe1e8;border-radius:8px;padding:8px 12px;line-height:1;cursor:pointer;font-weight:600;color:#374151;transition:all .15s}\n.oc-tab:hover{background:#eef3f8}\n.oc-tab.active{background:#fff;border-color:#169bd5;color:#169bd5;box-shadow:0 0 0 2px rgba(22,155,213,.12) inset}\n.oc-tabs.small .oc-tab{padding:6px 10px;font-weight:500;border-radius:6px}\n\n.oc-tab-pane{background:#fff;border:1px solid #e6eaef;border-radius:10px;padding:16px}\n\n.oc-f-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px}\n.oc-f-grid .oc-field{min-width:0}\n.oc-field label{display:block;font-size:13px;margin:0 0 6px 0;color:#6b7280}\n.oc-input, .oc-select, textarea.oc-input{width:100%;background:#fff;border:1px solid #d1d5db;border-radius:8px;padding:9px 12px;font-size:14px;outline:0;transition:border-color .15s,box-shadow .15s}\n.oc-input:focus, .oc-select:focus, textarea.oc-input:focus{border-color:#169bd5;box-shadow:0 0 0 3px rgba(22,155,213,.12)}\ntextarea.oc-input{resize:vertical}\n\n.oc-actions{display:flex;gap:8px;justify-content:flex-end}\n.oc-btn{background:#169bd5;color:#fff;border:none;border-radius:8px;padding:9px 14px;font-weight:700;cursor:pointer}\n.oc-btn:hover{filter:brightness(.95)}\n.oc-btn.ghost{background:#fff;color:#374151;border:1px solid #d1d5db}\n.oc-btn.ghost:hover{background:#f8fafc}\n\n.oc-ico-btn{border:1px solid #e2e8f0;background:#fff;border-radius:8px;padding:6px 8px;cursor:pointer}\n.oc-ico-btn:hover{background:#f6f9fc}\n\n.oc-bc.small{font-size:12px;color:#94a3b8;margin-top:2px}\n.oc-strong{font-weight:700}\n\n@media (max-width: 1024px){\n  .oc-f-grid{grid-template-columns:1fr}\n}\n\n\n.oc-parent-select {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* input + button in one row, same height as other inputs */\n.oc-parent-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.oc-parent-clear {\n  height: 38px;\n  padding-inline: 10px;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n/* current selection line (subtle, same width as field) */\n.oc-parent-current {\n  font-size: 12px;\n  color: #6b7280;\n  display: flex;\n  gap: 4px;\n}\n\n.oc-parent-current-label {\n  font-weight: 500;\n}\n\n.oc-parent-current-value {\n  color: #111827;\n}\n\n/* list styled like a dropdown but full-width, aligned to field */\n.oc-parent-list {\n  margin-top: 2px;\n  max-height: 180px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  overflow-y: auto;\n  padding: 4px;\n}\n\n.oc-parent-item {\n  width: 100%;\n  border: none;\n  background: transparent;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  padding: 4px 6px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.oc-parent-item:hover {\n  background: #f3f4f6;\n}\n\n.oc-parent-item.active {\n  background: #e5f0ff;\n  border: 1px solid #93c5fd;\n}\n\n.oc-parent-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.oc-parent-id {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n/* empty / helper rows */\n.oc-parent-empty {\n  padding: 4px 6px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n.oc-input-error {\n  border-color: #dc2626 !important;\n  background-color: #fef2f2;\n}\n\n.oc-field-error {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #dc2626;\n}\n\n.oc-form-error-banner {\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
